<template>
  <div>
    <div :class="$style.box" :style="{backgroundImage: `url(${bg})`}">
      <div :class="$style.bind">
        <p :class="$style.title">获取绑定码</p>
        <Field
          :class="$style.field"
          v-model.trim="userId"
          :type="1"
          placeHolder="用户id"
        ></Field>
        <p>绑定码：{{ code }}</p>
        <div :class="$style.sure" @click="submit">获取微信绑定码</div>
        <!-- <div :class="$style.sure" @click="submit(2)">获取支付宝绑定码</div> -->
        <div :class="$style.sure" @click="remove">清空绑定信息</div>
      </div>
    </div>
  </div>
</template>

<script>
import wxInit from "@/libs/wxinit";
import { bindRedPacketUser, getRedPacketUserInfo, getBindCode, clearBindData  } from "@/apis/sdkhb";
import { sort_ASCII } from "@/libs/utils";
import { CDN_URL } from "@/config";
import { Toast } from "vant";
import Field from "@/components/Field.vue";

export default {
  data() {
    return {
      name: "账号信息",
      bg: `https://assets.hzwxbz2.cn/sy/wxactivity/img/codeBindBg.jpg`,
      userId: "",
      userInfo: {},
      showBind: false,
      code: "",
    };
  },
  mounted() {
    wxInit();
    this.getUserInfo();
  },
  methods: {
    async getUserInfo() {
      const r = await getRedPacketUserInfo({
        wx_app_id: this.$route.meta.appId,
        code: this.$route.query.code,
        sign: sort_ASCII({
          wx_app_id: this.$route.meta.appId,
          code: this.$route.query.code
        })
      });
      if (r.ret === 1) {
        this.userInfo = r.content;
      }
    },
    async submit(type) {
      const r = await getBindCode({
        user_id: this.userId,
        type: 1,
        sign: sort_ASCII({
          user_id: this.userId,
          type: 1,
        })
      });
      if (r.ret == 1 && r.content.status == 0) {
        this.code = r.content.bind_code;
      } else {
        Toast('已绑定或请求失败')
      }
    },
    async remove() {
      const r = await clearBindData({
        wx_app_id: this.$route.meta.appId,
        openid: this.userInfo.openid,
      });
      if (r.ret === 1) {
        Toast("清空成功！", 2000);
      }
    },
    out() {
      window.wx.closeWindow();
    }
  },
  components: {
    Field,
  },
};
</script>

<style lang="scss" module>
.box {
  width: 100%;
  height: 100%;
  position: relative;
  background-size: 100%;
  background-repeat: no-repeat;
  .info {
    width: 300px;
    height: 240px;
    background-color: #FFFFFF;
    position: absolute;
    top: 180px;
    left: 50%;
    display: block;
    margin-left: -150px;
    box-sizing: content-box;
    padding-top: 20px;
    border-radius: 10px;
    > p:nth-child(1) {
      width: 100%;
      text-align: center;
      line-height: 30px;
      font-size: 16px;
    }
    .accWrap {
      height: 100px;
      overflow: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center; 
      overflow-y: auto;
      box-sizing: border-box; 
    }
    .account {
      width: 80%;
      font-size: 18px;
      line-height: 25px;
      text-align: center;
      margin: 10px auto;
      padding-bottom: 5px;
      border-bottom: 1px solid #dddddd;
    }
    .sure {
      width: 226px;
      height: 42px;
      background: #399fff;
      border-radius: 9px;
      line-height: 42px;
      text-align: center;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      margin-left: 50%;
      transform: translateX(-113px);
      margin-top: 20px;
    }
  }
  .bind {
    width: 300px;
    height: 340px;
    background-color: rgba(255, 255, 255);
    border-radius: 10px;
    position: absolute;
    top: 180px;
    left: 50%;
    display: block;
    margin-left: -150px;
    box-sizing: content-box;
    padding-top: 20px;
    .title {
      margin-bottom: 34px;
    }
    .back {
      position: absolute;
      top: 5px;
      left: 10px;
      width: 20px;
    }
    > p {
      width: 100%;
      text-align: center;
      line-height: 30px;
      font-size: 16px;
    }
    .field {
      margin-top: 14px;
      margin-left: 50%;
      transform: translateX(-113px);
    }
    .sure {
      width: 226px;
      height: 42px;
      background: #399fff;
      border-radius: 9px;
      line-height: 42px;
      text-align: center;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      margin-left: 50%;
      transform: translateX(-113px);
      margin-top: 50px;
    }
    .red {
      color: red;
      font-size: 20px;
      margin: 40px 0 5px;
    }
    .text {
      font-size: 12px;
      > span {
        color: red;
      }
    }
    .redirect {
      display: flex;
      color: #399fff;
      justify-content: space-between;
      padding: 25px 20px 10px;
    }
  }
  .add {
    color: #afaeae;
    font-size: 14px;
    text-align: center;
    margin-top: 10px;
  }
}
</style>